import { Flex } from '@grupoboticario/flora-react';
import { CalendarIcon, RoundCircleClockIcon } from '@grupoboticario/flora-react-icons';

import { ResponsiveFloraTypography } from 'components';
import { getShortDate, getShortCycle } from 'helpers';

import Styles from './CatalogCycleInfo.styles';

export const CatalogCycleInfos = ({
  cycleEnd,
  cycleId,
  cycleStart,
  isNextCycle,
  isUniqueLink,
}: {
  cycleEnd?: string;
  cycleId?: string;
  cycleStart?: string;
  isNextCycle?: boolean;
  isUniqueLink?: boolean;
}) => {
  const hasCurrentCycleInfos = cycleEnd && cycleId && cycleStart;
  const hasNextCycleInfos = cycleId && cycleStart;

  if (isNextCycle && hasNextCycleInfos) {
    return (
      <>
        <Flex align='center' gap='$2'>
          <RoundCircleClockIcon aria-hidden />
          <ResponsiveFloraTypography fontWeight='medium'>
            Ciclo {getShortCycle(cycleId)}
          </ResponsiveFloraTypography>
        </Flex>
        <Flex align='center' gap='$2'>
          <CalendarIcon aria-hidden />
          <ResponsiveFloraTypography fontWeight='medium'>{`A partir de ${getShortDate(
            cycleStart
          )}`}</ResponsiveFloraTypography>
        </Flex>
      </>
    );
  }
  if (hasCurrentCycleInfos) {
    return (
      <>
        <Flex align='center' gap='$2'>
          <RoundCircleClockIcon />
          <ResponsiveFloraTypography fontWeight='medium'>
            Ciclo {getShortCycle(cycleId)}
          </ResponsiveFloraTypography>
        </Flex>
        <Flex align='center' gap='$2'>
          <CalendarIcon />
          <ResponsiveFloraTypography fontWeight='medium'>
            {getShortDate(cycleStart)} a {getShortDate(cycleEnd)}
          </ResponsiveFloraTypography>
        </Flex>
      </>
    );
  }

  if (isUniqueLink) {
    return (
      <Styles.UniqueLinkWrapper>
        <ResponsiveFloraTypography fontWeight='medium'>
          Link único que contém todos os catálogos
        </ResponsiveFloraTypography>
      </Styles.UniqueLinkWrapper>
    );
  }
  return <></>;
};
